import React from 'react';

import { QSpinner, QText } from '@qualio/ui-components';

const ActiveStatusFilter = ({ value, statusMap }: { value: unknown; statusMap: Record<string, string> }) => {
  const id = value as string;
  const status = statusMap[id];
  if (status) {
    return <QText>{status}</QText>;
  }
  return <QSpinner size="sm" />;
};

export default ActiveStatusFilter;
